function findOwnerFitnessProfile(profiles, user) {
	if (!profiles?.length) return null;

	const normalizedEmail = user?.email?.trim().toLowerCase();
	if (normalizedEmail) {
		const emailMatch = profiles.find(
			(profile) => profile.email?.trim().toLowerCase() === normalizedEmail
		);
		if (emailMatch) return emailMatch;
	}

	return profiles.find((profile) => profile.is_primary) || profiles[0];
}

/** Profiles shown on the AI Trainer landing picker for the current session. */
export function aiTrainerListProfiles({ profiles, activeFitnessProfile, user }) {
	const list = profiles || [];

	if (activeFitnessProfile?.id) {
		const mine = list.find((profile) => profile.id === activeFitnessProfile.id);
		return mine ? [mine] : [];
	}

	const mine = findOwnerFitnessProfile(list, user);
	return mine ? [mine] : [];
}

/** Whether a deep-linked profile_id is allowed for this session. */
export function resolveAiTrainerDeepLinkProfileId({ profileId, profiles, activeFitnessProfile }) {
	const id = Number(profileId);
	if (!id || Number.isNaN(id)) return null;

	const list = profiles || [];

	if (activeFitnessProfile?.id) {
		return id === activeFitnessProfile.id ? id : null;
	}

	if (list.some((profile) => profile.id === id)) {
		return id;
	}

	return null;
}

export function isAiTrainerHouseholdSession(activeFitnessProfile) {
	return Boolean(activeFitnessProfile?.id);
}
